
import { MessageBoxActionType, MessageBoxEvent } from '@/types/MessageBox'
import { EventBuss } from '@/types/global'

import { Emitter, computed, defineComponent, inject, ref } from 'vue'
import { iconX } from '@/components/icon'
import { useI18n } from 'vue-i18n'

import { isIpadPro } from '@/utils'
export default defineComponent({
    components: {

        'icon-x': iconX
    },
    setup() {
        const emitter = inject('emitter') as Emitter
        const { t } = useI18n()

        const tabIndex = ref<number>(0)





        const close = () => {


            const _event: MessageBoxEvent = {
                type: MessageBoxActionType.close,
                name: 'rule'
            }
            emitter.emit(EventBuss.DIALOG, _event)
        }

        const isIpadProDevice = computed((): boolean => isIpadPro())

        return {
            isIpadProDevice,
            tabIndex,
            close,
            t
        }
    }
})
